import { render, staticRenderFns } from "./PaymentDetails.vue?vue&type=template&id=bb5814d2&scoped=true"
import script from "./PaymentDetails.vue?vue&type=script&lang=js"
export * from "./PaymentDetails.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetails.vue?vue&type=style&index=0&id=bb5814d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5814d2",
  null
  
)

export default component.exports